import { Injectable } from '@angular/core';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private snackBar: MatSnackBar) {}
  success(message: string) {
    if (message) {
      this.snackBar.open(message, 'Close', {
        duration: 5000,
        verticalPosition: 'bottom',
        horizontalPosition: 'end',
      });
    }
  }

  error(message: string) {
    if (message) {
      this.snackBar.open(message, 'Close', {
        duration: 5000,
        verticalPosition: 'bottom',
        horizontalPosition: 'end',
      });
    }
  }
  warning(message: string) {
    if (message) {
      this.snackBar.open(message, 'Close', {
        duration: 5000,
        verticalPosition: 'bottom',
        horizontalPosition: 'end',
      });
    }
  }
  info(message: string) {
    if (message) {
      this.snackBar.open(message, 'Close', {
        duration: 5000,
        verticalPosition: 'bottom',
        horizontalPosition: 'end',
      });
    }
  }
}
